// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Breadcrumbs_breadcrumbs__PGk-B {
  grid-area: breadcrumbs;
  min-height: 2.1rem;
}
.Breadcrumbs_breadcrumbs__PGk-B ol {
  padding: 0.5em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.Breadcrumbs_breadcrumbs__PGk-B ol li {
  margin: 0.25em 0;
}
.Breadcrumbs_breadcrumbs__PGk-B ol .Breadcrumbs_separator__uXtRZ {
  color: var(--foreground-color-3);
  margin: 0 0.25em;
}`, "",{"version":3,"sources":["webpack://./src/views/Template/components/Menu/Breadcrumbs.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EAEA,kBAAA;AAAF;AACE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AACJ;AAAI;EACE,gBAAA;AAEN;AAAI;EACE,gCAAA;EACA,gBAAA;AAEN","sourcesContent":[".breadcrumbs {\n  grid-area: breadcrumbs;\n  // button has height = 1.6rem, plus li margins\n  min-height: 2.1rem;\n  ol {\n    padding: 0.5em;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    li {\n      margin: 0.25em 0;\n    }\n    .separator {\n      color: var(--foreground-color-3);\n      margin: 0 0.25em;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbs": `Breadcrumbs_breadcrumbs__PGk-B`,
	"separator": `Breadcrumbs_separator__uXtRZ`
};
export default ___CSS_LOADER_EXPORT___;
